import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AppThemeProvider } from '@content-agents/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './app/router';
import { AuthProvider } from './features/auth/auth.context';
import { I18nProvider, useI18n } from './i18n/i18n';
import { queryClient } from './lib/query-client';
import { registerServiceWorker } from './lib/pwa';
import 'antd/dist/reset.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

registerServiceWorker();

// Bridges the current locale's direction into the AntD theme provider.
function ThemedApp() {
  const { dir } = useI18n();
  return (
    <AppThemeProvider direction={dir}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </AppThemeProvider>
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <ThemedApp />
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
